<template>
  <div class="container">
    <Step :active-step="3">
      <template slot="step">
        ÜRÜN ÖZELLİKLERİ
      </template>
      <template slot="nextStep">
        Sonraki Adım: Ürün Görselleri
      </template>
    </Step>
    <section>
      <div class="header">
        Ürün Özelliklerini Giriniz
      </div>
      <div
        class="row"
        v-for="(other, i) in getSortedOthers"
        :key="i"
      >
        <label class="label">
          {{ other.name }}
          <span
            class="required"
            v-if="other.validation.required"
          >
            *
          </span>
        </label>
        <div>
          <DynamicInput
            :attr="other"
            data-vv-validate-on="change|input"
            :class="{'is-invalid' : errors.has(other.props.name), 'form-control': other.className}"
            v-validate="other.validation"
            v-model="formData.productOthers[other.id]"
            v-readonly
          />
          <div class="invalid-feedback">
            {{ errors.first(other.props.name) }}
          </div>
        </div>
      </div>
    </section>
    <div class="button-wrapper">
      <button
        type="button"
        class="btn btn-secondary"
        @click="onPrevStep"
      >
        GERİ DÖN
      </button>
      <button
        type="button"
        class="btn btn-trendyol"
        @click="onNextStep"
      >
        DEVAM ET
      </button>
    </div>
    <Confirm
      :show="showConfirm"
      @close="closeConfirm"
    >
      <template slot="confirm-body">
        <div class="confirm-content">
          <div class="icon-container">
            <img :src="`${$root.cdnUrl}assets/icon-document-missing.svg`">
          </div>
          <h5>
            Yüklemekte Olduğunuz Ürünün Bazı İçerikleri Eksik!
          </h5>
          <p>
            Ürün bilgilerinizi eksiksiz girerek müşterilerin ürününüze daha kolay ulaşmasını sağlayabilirsiniz.
          </p>
          <div class="button-container">
            <div>
              <button
                class="btn btn-trendyol"
                @click="closeConfirm"
              >
                EKSİK ALANLARI DOLDUR
              </button>
            </div>
            <div>
              <button
                class="btn btn-secondary"
                @click="onContinue"
              >
                YOKSAY VE DEVAM ET
              </button>
            </div>
          </div>
        </div>
      </template>
    </Confirm>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import DynamicInput from './Components/DynamicInput';
import Step from './Components/Step';
import Confirm from '@/components/Confirm';

export default {
  name: 'ProductProperty',
  components: {
    Confirm,
    Step,
    DynamicInput,
  },
  data () {
    return {
      formData: {},
      showConfirm: false,
    };
  },
  computed: {
    ...mapGetters({
      getFormData: 'singleProduct/getFormData',
      getOthers: 'singleProduct/getOthers',
    }),
    getSortedOthers () {
      const others = this.getOthers;
      if (others.length > 0) {
        return others.sort((a, b) => b.validation.required - a.validation.required);
      }
      return [];
    },
  },
  methods: {
    ...mapActions({
      setFormData: 'singleProduct/setFormData',
    }),
    async validate () {
      const result = await this.$validator.validateAll();
      if (result) {
        const afterValidate = await this.afterValidate();
        if (afterValidate) {
          this.setFormData(this.formData);
          return true;
        }
      }
      return false;
    },
    async afterValidate () {
      const filledProductOthers = Object.keys(this.formData.productOthers);
      if (this.getOthers.length > filledProductOthers.length) {
        this.showConfirm = true;
        return false;
      }
      return true;
    },
    closeConfirm () {
      this.showConfirm = false;
    },
    onPrevStep () {
      this.$router.push({
        name: 'ProductSaleInfo',
      });
    },
    async onNextStep () {
      const isValid = await this.validate();
      if (isValid) {
        this.onContinue();
      }
    },
    async onContinue () {
      this.closeConfirm();
      this.$root.trackEvent({
        eventCategory: 'MobileAppListing',
        eventAction: 'ÜrünListesiDropdownMenüAçanlar',
        eventLabel: 'ÜrünListesiDropdownMenüTekilÜrünEkleme3.adim',
      });
      setTimeout(() => this.$router.push({
        name: 'ProductImage',
      }), 100);
    },
  },
  async created () {
    this.formData = this.getFormData;
    window.scrollTo(0, 0);
  },
};
</script>

<style lang="scss">
  .confirm-content {
    font-size: 14px;
    color: #273142;
    text-align: center;
    .icon-container {
      margin-bottom: 30px;
    }
    h5{
      font-size: 20px;
      color: #f27a1a;
    }

    .button-container{
      & > div{
        margin-bottom: 20px;
        &:last-child {
          margin-bottom: 0;
        }
        .btn {
          display: block;
          width: 100%;
          margin: 0 auto;
        }
      }
    }
  }
</style>
